// This has to a relative import. It's used by packages/ui/src/components/data-display/money/useMoney.unit.test.ts which imports the siteConfig which in turn imports this file.
// If this file uses a tsconfig path import the tsconfig in packages/ui will not be able to resolve it and it will fail.
import { Market } from "../../../config/site/types";

//Before Headless each market had its own formats for orders. This validators cover these requirements
export const OrderValidationFormat: Record<Market, RegExp> = {
    [Market.MY]: /^(#?MY-\d{11}|MY\d{9}|8700-\d{6}|8700R-\d{6})$/,
    [Market.SG]: /^(#?(DE|EC)\d{8}|SG\d{9}|(3800|3800R)-(\d{6}|\d{9}))$/,
    [Market.ES]: /^(#?ES\d{8}|3600-\d{6}|RO-36\d{9})$/,
    [Market.EE]: /^(#?EE-\d{11}|EE\d{8}|SO-760\d{7}|RO-76\d{9})$/,
    [Market.IN]: /^(#?DE\d{8}|EC\d{8}|IN\d{9}|3820-\d{6}|SO-38\d{9})$/,
    [Market.KR]: /^(#?DE\d{8}|EC\d{8}|KR\d{9}|6800-\d{6}|SO-68\d{9}|6800R-\d{6})$/,
    [Market.JP]: /^(#?(DE|EC)\d{8}|JP\d{9}|SO-(\d{9,10})|6100-\d{5}|6100R-\d{7})$/,
    [Market.AU]: /^(#?(DE|EC)\d{8}|AU\d{9}|ST200-\d{6}|ST-\d{9}|200RO-\d{6,7})$/,
    [Market.NZ]: /^(#?(DE|EC)\d{8}|NZ\d{9}|ST200-\d{6}|ST-\d{9}|200RO-\d{6,7})$/,
    [Market.CA]: /^(#?(DE|EC)\d{8}|CA\d{9}|(S8|R7|R8)\d{8})$/,
    [Market.US]: /^(#?(DE|EC)\d{8}|US\d{9}|(S7|R7)\d{8})$/,
    // Revisit later if these markets enable live chat and contact form for a more exact regex.
    [Market.GB]: /^(#?GB\d{8})$/,
    [Market.PL]: /^(#?PL\d{8})$/,
    [Market.PT]: /^(#?PT\d{8})$/,
    [Market.HU]: /^(#?HU\d{8})$/,
    [Market.HR]: /^(#?HR\d{8})$/,
    [Market.SK]: /^(#?SK\d{8})$/,
    [Market.SI]: /^(#?SI\d{8})$/,
    [Market.FR]: /^(#?FR\d{8})$/,
    [Market.BE]: /^(#?BE\d{8})$/,
    [Market.CZ]: /^(#?CZ\d{8})$/,
    [Market.AT]: /^(#?AT\d{8})$/,
    [Market.CH]: /^(#?CH\d{8})$/,
    [Market.DE]: /^(#?DE\d{8})$/,
    [Market.NL]: /^(#?NL\d{8})$/,
    [Market.DK]: /^(#?DK\d{8})$/,
    [Market.FI]: /^(#?FI\d{8})$/,
    [Market.IE]: /^(#?IE\d{8})$/,
    [Market.LT]: /^(#?LT\d{8})$/,
    [Market.LV]: /^(#?LV\d{8})$/,
    [Market.NO]: /^(#?NO\d{8})$/,
    [Market.SE]: /^(#?SE\d{8})$/,
    [Market.CY]: /^(#?CY\d{8})$/,
};
